import { getSellProducts, createNewOrder, updateOrder, abrogateOrder, checkPendingOrder, pushInfo } from '@/api/order';
import useLoading from '@/utils/loading';
export default {
  namespaced: true,
  state: {
    orderStep: 1,
    orderInformation: {},
    promotionNews: '',
    order_id: null,
    pendingOrderId: null,
    memo: '', // 整單備註
  },

  getters: {
    getStep: (state) => state.orderStep,
    getOrderInfo: (state) => state.orderInformation,
    getSource: (state) => state.orderInformation.source,
    getTakeAwayMethod: (state) => state.orderInformation.take_away_method,
    getNews: (state) => state.promotionNews,
    getOrderId: (state) => state.order_id,
    getPendingOrderId: (state) => state.pendingOrderId,
    getMemo: (state) => state.memo,
  },

  mutations: {
    SET_STEP(state, data) {
      state.orderStep = data;
    },
    SET_INFORMATION(state, data) {
      state.orderInformation = { ...state.orderInformation, ...data };
    },
    SET_NEWS(state, data) {
      state.promotionNews = data;
    },
    SET_ORDER_ID(state, data) {
      state.order_id = data;
    },
    SET_PENDING_ORDER_ID(state, data) {
      state.pendingOrderId = data;
    },
    SET_MEMO(state, data) {
      state.memo = data;
    },
    RESET(state) {
      state.orderStep = 1;
      state.orderInformation = {};
      state.promotionNews = '';
      state.order_id = null;
      state.memo = '';
    },
  },

  actions: {
    //建立訂單並取得商品資訊
    async doCreateNewOrder({ dispatch }, info) {
      // 建立訂單api
      const order_basic = {
        source: info.source,
        take_away_method: info.take_away_method,
        note: info.consumer.note,
        order_user_name: info.consumer.order_user_name,
        order_user_tel: info.consumer.order_user_tel,
        order_user_address: info.consumer.order_user_address,
        order_take_time: info.consumer.order_take_time,
        outside_order_id: info.consumer.outside_order_id,
        pos_note: info.consumer.pos_note,
      };
      const {
        information,
        transaction,
        cart,
        invoice_info,
        promotion,
        payment,
        permission,
        order_id,
        card_info,
        member_card,
      } = await createNewOrder(order_basic);
      // 取得商品
      const order_data = {
        source: info.source,
        take_away_method: info.take_away_method,
      };
      const { menu, products, addon_list, discount_list, ticket_list } = await getSellProducts(order_data);

      //更新vuex資料
      await dispatch('doUpdateData', {
        order_id,
        information,
        promotion,
        transaction,
        invoice_info,
        payment,
        permission,
        cart,
        card_info,
        member_card,
        menu,
        products,
        addon_list,
        discount_list,
        ticket_list,
      });
      return Promise.resolve();
    },
    //建立vuex所有訂單資料
    doUpdateData({ commit, dispatch }, data) {
      useLoading(true);
      commit('SET_ORDER_ID', data.order_id);
      sessionStorage.setItem('order_id', data.order_id);
      commit('SET_INFORMATION', data.information);
      commit('SET_MEMO', data.information.pos_note); // 整單備註
      commit('SET_NEWS', data.promotion.message);
      commit('checkout/SET_TRANSACTION', data.transaction, { root: true }); //建立交易資訊
      commit('checkout/SET_INVOICE_INFO', data.invoice_info, { root: true }); //建立發票資訊
      commit('checkout/SET_PAYMENT', data.payment, { root: true }); //建立付款資訊
      commit('checkout/SET_PERMISSION', data.permission, { root: true }); //建立結帳資訊
      commit('cart/SET_CART_DATA', data.cart, { root: true }); //建立購物車商品資料
      commit('member/SET_DAYUNGS_PAYMENT', data.card_info, { root: true }); //建立旺卡資料
      commit('member/SET_MEMBER', data.member_card, { root: true }); //建立會員資料
      commit('list/SET_TAB_LIST', data.menu, { root: true }); //建立商品tab_list
      commit('list/SET_ALL_PRODUCTS', data.products, { root: true }); //建立所有商品庫
      commit('list/SET_ALL_PRODUCTS_ADD_ON', data.addon_list, { root: true }); //建立所有容量對應加料清單
      commit('list/SET_ENTERTAIN_LIST', data.discount_list, { root: true }); //建立整單折扣清單
      commit('list/SET_TICKET_LIST', data.ticket_list, { root: true }); //建立電子券清單
      commit('SET_STEP', 2);
      dispatch('menuItem/doSetTab', data.menu[0], { root: true }); //設定選擇第一個商品tab
      useLoading(false);
      return Promise.resolve();
    },
    //修改訂單資訊
    async doUpdateOrder({ commit, getters }, info) {
      // 修改訂單api
      const order_id = getters.getOrderId;
      let data = {
        order_id,
        note: info.consumer.note,
        order_user_name: info.consumer.order_user_name,
        order_user_tel: info.consumer.order_user_tel,
        order_user_address: info.consumer.order_user_address,
        order_take_time: info.consumer.order_take_time,
        outside_order_id: info.consumer.outside_order_id,
        pos_note: info.consumer.pos_note,
      };
      const res = await updateOrder(data);
      //更新vuex資料
      commit('SET_INFORMATION', res.information);
      return Promise.resolve();
    },
    // 修改整單備註
    async doUpdateOrderMemo({ commit, getters }, memo) {
      const order_id = getters.getOrderId;
      let data = {
        order_id,
        pos_note: memo,
      };
      const res = await updateOrder(data);
      //更新vuex資料
      commit('SET_MEMO', res.information.pos_note);
      return Promise.resolve();
    },
    async doUpdateOrderNote({ commit, getters }, note) {
      const order_id = getters.getOrderId;
      let data = { order_id, note };
      const res = await updateOrder(data);
      //更新vuex資料
      commit('SET_INFORMATION', res.information);
      return Promise.resolve();
    },
    //重新點餐(放棄訂單)
    async doAbrogateOrder({ dispatch, getters }) {
      console.log('getters', getters);
      const order_id = getters.getOrderId;
      const { status } = await abrogateOrder({ order_id });
      if (!status) return;
      await dispatch('doRestartOrder');
      return Promise.resolve();
    },
    //取得未完成訂單編號
    async doCheckPendingOrder({ commit }) {
      const res = await checkPendingOrder({});
      commit('SET_PENDING_ORDER_ID', res.order_id);
      commit('SET_ORDER_ID', res.order_id);
    },
    //重新開始一個新的訂單
    doRestartOrder({ commit }) {
      commit('member/RESET', '', { root: true });
      commit('list/RESET', '', { root: true });
      commit('menuItem/RESET', '', { root: true });
      commit('cart/RESET', '', { root: true });
      commit('RESET');
      setTimeout(() => {
        commit('checkout/RESET', '', { root: true });
      }, 100);
      return Promise.resolve();
    },
    //存資料給客顯使用
    async doPushInfoForGuest({ commit }, { type, data }) {
      // console.log('pushInfoForGuest', type, data);
      await pushInfo({ action: type, data: data });

      return Promise.resolve();
    },
  },
};
